import { Box, Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import React from "react";
import useLocalization from "hooks/useLocalization";

interface ContactSupportModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  closeButtonText?: string;
}

const ContactSupportModal: React.FC<ContactSupportModalProps> = ({
  open,
  onClose,
  title,
  closeButtonText,
}) => {
  const { currentLocale } = useLocalization();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        {title || currentLocale.botBuilder.builderTemplate.contactSupport.title}
      </DialogTitle>

      <Box
        sx={{
          width: "100%",
          height: "70vh",
          minHeight: "600px",
          maxHeight: "800px",
        }}
      >
        <iframe
          src="https://funner.co.il/supportstandalone"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          title="Support Form"
        />
      </Box>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {closeButtonText ||
            currentLocale.botBuilder.builderTemplate.contactSupport.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactSupportModal;
